import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Booking } from './pages/Booking';
import { Stub } from './pages/Stub';
import { ServicesList } from './pages/ServicesList';
import { ServiceDetail } from './pages/ServiceDetail';
import { Blog } from './pages/Blog';
import { Contact } from './pages/Contact';
import { PatientInformation } from './pages/PatientInformation';
import { FAQ } from './pages/FAQ';
import { Privacy } from './pages/Privacy';
import { Terms } from './pages/Terms';
import { About } from './pages/About';
import { BlogPost } from './pages/BlogPost';
export function App() {
  return <BrowserRouter data-id="element-0">
      <Layout data-id="element-1">
        <Routes data-id="element-2">
          <Route path="/" element={<Home data-id="element-4" />} data-id="element-3" />
          <Route path="/book" element={<Booking data-id="element-6" />} data-id="element-5" />

          {/* Fully built pages */}
          <Route path="/patient-information" element={<PatientInformation data-id="element-8" />} data-id="element-7" />
          <Route path="/blog" element={<Blog data-id="element-10" />} data-id="element-9" />
          <Route path="/blog/:id" element={<BlogPost data-id="element-12" />} data-id="element-11" />
          <Route path="/contact" element={<Contact data-id="element-14" />} data-id="element-13" />
          <Route path="/services" element={<ServicesList data-id="element-16" />} data-id="element-15" />
          <Route path="/services/:slug" element={<ServiceDetail data-id="element-18" />} data-id="element-17" />
          <Route path="/faq" element={<FAQ data-id="element-20" />} data-id="element-19" />
          <Route path="/privacy" element={<Privacy data-id="element-22" />} data-id="element-21" />
          <Route path="/terms" element={<Terms data-id="element-24" />} data-id="element-23" />
          <Route path="/about" element={<About data-id="element-26" />} data-id="element-25" />

          {/* Coming-soon pages */}
          <Route path="/doctors" element={<Stub data-id="element-28" />} data-id="element-27" />
          <Route path="/facilities" element={<Stub data-id="element-30" />} data-id="element-29" />
        </Routes>
      </Layout>
    </BrowserRouter>;
}